import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'
import { tenant } from '../services/ConfigService'
import helpers from './helpers'
import logger from './logger'

const { PACKAGE_VERSION } = process.env
const environment = helpers.getGenericEnvironment()
const anonUserId = Cookies.get('je-auser') || uuidv4()

/**
 * Formatted JETFM Message and Tags log
 * @param {String} message JETFM log
 * @param {Array} tags JETFM tags
 */
function logMessageAndTags(message, tags = []) {
  return tags.length > 0 ? `${message} With tags: ${tags.join(',')}` : message
}

const log = {
  info(message, tags, payload = {}) {
    const messageLog = logMessageAndTags(message, tags)
    logger.info(messageLog, payload)
  },
  warn(message, tags, payload = {}) {
    const messageLog = logMessageAndTags(message, tags)
    logger.warn(messageLog, payload)
  },
  error(message, exception, tags, payload = {}) {
    const messageLog = logMessageAndTags(message, tags)
    logger.error(messageLog, payload)
  }
}

// https://pages.github.je-labs.com/experimentation-platform/portal-documentation/docs/sdks/javascript/usage#settings-version--3xx-js-sdk-custom-audiences
const settings = {
  keyPrefix: 'jet-consumerweb', // the key prefix - usually your team / component scope 'web-core-platforms'
  cdn: {
    host: 'https://features.api.justeattakeaway.com', // We can provide hosts for other AWS environments, but use this by default
    scope: 'jet-consumerweb', // your team / component scope - usually the same as keyPrefix
    environment, // development | production
    key: '', // obfuscation key provided with scope
    poll: false, // true | false - enable if you want to poll. Ensure interval is set.
    pollInterval: 1000 * 60 // How frequently config should be polled for in ms
  },
  // Provides filterable properties that are used in deciding requested feature values
  getContext: () => ({
    anonUserId, // UUID
    restrictionsProviders: new Map()
      .set('Country', () => tenant)
      .set('AppVersion', () => PACKAGE_VERSION)
  }),
  log,
  onTrack: () => undefined,
  // initialConfigAsJson: cachedConfigString,
  urlString: window.location.href
  // Optional - If passed in during setup then if an attempt to override a feature is made via the querystring then this url will be used to find a match against an active feature.
}

export default settings
